import { styled } from '@material-ui/core/styles'

export const PreviewImage = styled('img')(() => ({
  objectFit: 'contain',
  maxHeight: 500,
  pointerEvents: 'none'
}))
